import React from 'react';
import styled from 'styled-components';
import { FaInstagram, FaFacebook, FaEtsy } from 'react-icons/fa';

// Styled Components
const PageContainer = styled.div`
  max-width: 1200px;
  margin: 6rem auto 0; /* Reduced bottom margin to 0 */
  padding: 2rem;
  text-align: center;
  min-height: calc(100vh - 6rem - 200px); /* Ensure it takes up remaining viewport height, accounting for nav and footer */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Title = styled.h1`
  color: #7A4988;
  font-size: 2.4rem;
  margin-bottom: 2rem;
  font-family: 'Poppins', sans-serif;
`;

const FAQContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  max-width: 800px;
  margin: 0 auto;
  flex-grow: 1; /* Allow FAQ content to grow and push footer down */
`;

const FAQItem = styled.div`
  text-align: left;
  width: 100%;
`;

const Question = styled.h2`
  color: #7A4988;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  font-family: 'Dancing Script', cursive;
`;

const Answer = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: #444;
  font-family: 'Poppins', sans-serif;
`;

// Footer
const Footer = styled.footer`
  padding: 3rem 2rem 1.5rem;
  background-color: #7A4988;
  color: #fff;
  font-family: 'Poppins', sans-serif;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 1.2rem;
  position: relative;
  padding-bottom: 0.5rem;
  
  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 30px;
    height: 2px;
    background-color: #FFAAD7;
  }
`;

const FooterLink = styled.a`
  color: #F3E3F7;
  text-decoration: none;
  margin-bottom: 0.8rem;
  transition: all 0.3s ease;
  
  &:hover {
    color: #FFAAD7;
    transform: translateX(3px);
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
`;

const SocialIcon = styled.a`
  color: #F3E3F7;
  font-size: 1.5rem;
  transition: all 0.3s ease;
  
  &:hover {
    color: #FFAAD7;
    transform: translateY(-3px);
  }
`;

const Copyright = styled.div`
  text-align: center;
  padding-top: 2rem;
  margin-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.9rem;
`;

function FAQ() {
  return (
    <>
      <PageContainer>
        <div>
          <Title>Frequently Asked Questions</Title>
          <FAQContainer>
            <FAQItem>
              <Question>How do I care for crochet items?</Question>
              <Answer>
                We recommend handwashing your crochet items and laying them flat to dry. This helps maintain their shape and quality over time.
              </Answer>
            </FAQItem>
            <FAQItem>
              <Question>What age is it safe for children to have crochet items with safety eyes?</Question>
              <Answer>
                We do not typically use safety eyes on pre-made items because they can be a hazard to children below the age of five years old. For safety, we avoid using them in our ready-to-ship products.
              </Answer>
            </FAQItem>
          </FAQContainer>
        </div>
      </PageContainer>

      {/* Footer */}
      <Footer>
        <FooterContent>
          <FooterSection>
            <FooterTitle>Quick Links</FooterTitle>
            <FooterLink href="/">Home</FooterLink>
            <FooterLink href="/custom-order">Custom Orders</FooterLink>
            <FooterLink href="/faq">FAQ</FooterLink>
          </FooterSection>

          <FooterSection>
            <FooterTitle>Policies</FooterTitle>
            <FooterLink href="/shipping">Shipping</FooterLink>
            <FooterLink href="/returns">Returns</FooterLink>
            <FooterLink href="/privacy">Privacy Policy</FooterLink>
            <FooterLink href="/terms">Terms of Service</FooterLink>
          </FooterSection>

          <FooterSection>
            <FooterTitle>Connect With Us</FooterTitle>
            <p>Follow us for updates and behind-the-scenes content!</p>
            <SocialLinks>
              <SocialIcon href="https://www.instagram.com/lavenderandpalmcrochet/">
                <FaInstagram />
              </SocialIcon>
              <SocialIcon href="https://www.facebook.com/people/Lavender-and-Palm-Crochet/61566023416208/#">
                <FaFacebook />
              </SocialIcon>
              <SocialIcon href="https://lavenderandpalm.etsy.com">
                <FaEtsy />
              </SocialIcon>
            </SocialLinks>
          </FooterSection>
        </FooterContent>

        <Copyright>
          © {new Date().getFullYear()} Lavender & Palm Co. All rights reserved.
        </Copyright>
      </Footer>
    </>
  );
}

export default FAQ;